export default "__VITE_ASSET__56b6aa52__"